import React, { useEffect, useMemo, useState } from 'react';
import { signOut } from 'firebase/auth';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  serverTimestamp,
  setDoc,
  where,
} from 'firebase/firestore';
import { getDownloadURL, listAll, ref, uploadBytes } from 'firebase/storage';
import { auth, db, storage } from '../firebaseConfig';

const homeInjectedStyles = `
  * {
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overscroll-behavior-x: none;
    background: #0d0d0d;
  }

  body {
    color: #fff;
  }

  #root {
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    background: #0d0d0d;
  }

  .ink-home-screen {
    min-height: 100vh;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    overscroll-behavior-x: none;
    background: linear-gradient(180deg, #0d0d0d 0%, #131313 100%);
    color: #fff;
    padding: 12px 16px 42px;
    font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  }

  .ink-home-screen .home-shell {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    background: transparent;
  }

  .ink-home-screen .home-topbar {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 14px;
  }

  .ink-home-screen .logout-floating-btn {
    position: static;
    z-index: 20;
    border: 1px solid rgba(255,255,255,0.18);
    background: rgba(255,255,255,0.06);
    color: #fff;
    border-radius: 13px;
    padding: 9px 12px;
    min-width: 96px;
    font-size: 0.92rem;
    font-weight: 800;
    cursor: pointer;
    box-shadow: 0 10px 30px rgba(0,0,0,0.22);
    transition: transform .18s ease, opacity .18s ease, box-shadow .18s ease;
  }

  .ink-home-screen .logout-floating-btn:hover {
    transform: translateY(-1px);
  }

  .ink-home-screen .home-container {
    width: 100%;
    max-width: 920px;
    margin: 0 auto;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.10);
    backdrop-filter: blur(10px);
    border-radius: 28px;
    padding: 24px;
    box-shadow: 0 18px 60px rgba(0,0,0,0.34);
    overflow: visible;
    display: grid;
    gap: 22px;
  }

  .ink-home-screen .aluno-section,
  .ink-home-screen .home-grid-section,
  .ink-home-screen .professor-section {
    background:
      radial-gradient(circle at top, rgba(255,255,255,0.03), transparent 35%),
      rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 24px;
    padding: 22px;
    box-shadow: 0 14px 40px rgba(0,0,0,0.20);
  }

  .ink-home-screen .aluno-section-head,
  .ink-home-screen .section-head {
    margin-bottom: 16px;
  }

  .ink-home-screen .aluno-badge-light {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 12px;
    border-radius: 999px;
    background: rgba(255,91,91,0.12);
    border: 1px solid rgba(255,91,91,0.24);
    color: #ff7b7b;
    font-size: 0.78rem;
    font-weight: 900;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    text-shadow: 0 0 10px rgba(255, 91, 91, 0.22);
  }

  .ink-home-screen .course-title {
    margin: 10px 0 0;
    font-size: clamp(1.35rem, 3vw, 2rem);
    color: #fff;
  }

  .ink-home-screen .section-subtitle {
    margin: 8px 0 0;
    color: rgba(255,255,255,0.72);
    line-height: 1.6;
    font-size: 0.95rem;
  }

  .ink-home-screen .professor-card,
  .ink-home-screen .professor-aula-box {
    width: 100%;
  }

  .ink-home-screen .professor-panel {
    width: 100%;
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  .ink-home-screen .aluno-greeting {
    margin: 0;
    font-size: clamp(1.45rem, 3vw, 2.1rem);
    color: #fff;
    line-height: 1.15;
  }

  .ink-home-screen .aluno-greeting strong {
    color: #ff8d8d;
    text-shadow: 0 0 12px rgba(255, 91, 91, 0.18);
  }

  .ink-home-screen .professor-avatar {
    width: 64px;
    height: 64px;
    min-width: 64px;
    border-radius: 20px;
    background: linear-gradient(135deg, rgba(255,91,91,0.28), rgba(255,255,255,0.07));
    border: 1px solid rgba(255,91,91,0.22);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 1.45rem;
    font-weight: 900;
    box-shadow: 0 12px 28px rgba(255,91,91,0.14);
  }


  .ink-home-screen .aulas-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .ink-home-screen .aula-card-button {
    border: 1px solid rgba(255,255,255,0.10);
    background:
      radial-gradient(circle at top, rgba(255,255,255,0.04), transparent 45%),
      rgba(255,255,255,0.04);
    color: #fff;
    border-radius: 18px;
    padding: 12px 11px;
    min-height: 124px;
    aspect-ratio: 1 / 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    cursor: pointer;
    gap: 4px;
    box-shadow: 0 12px 30px rgba(0,0,0,0.18);
    transition: transform .18s ease, border-color .18s ease, background .18s ease;
  }

  .ink-home-screen .aula-card-button:hover:not(:disabled) {
    transform: translateY(-2px);
    border-color: rgba(255,91,91,0.22);
    background: rgba(255,255,255,0.06);
  }

  .ink-home-screen .aula-card-button:disabled {
    opacity: 0.68;
    cursor: not-allowed;
  }

  .ink-home-screen .aula-numero {
    font-size: 0.72rem;
    font-weight: 900;
    letter-spacing: 0.08em;
    color: #ff7b7b;
    margin-bottom: 2px;
  }

  .ink-home-screen .aula-status {
    font-weight: 900;
    margin-bottom: 2px;
    line-height: 1.1;
  }

  .ink-home-screen .aula-data {
    color: rgba(255,255,255,0.74);
    font-size: 0.82rem;
    line-height: 1.15;
  }

    .ink-home-screen .professor-panel {
    padding: 0;
  }

  .ink-home-screen .professor-helper-text {
    margin: 0;
    color: rgba(255,255,255,0.72);
    line-height: 1.6;
  }

  .ink-home-screen .professor-card-toggle:hover,
  .ink-home-screen .professor-aula-toggle:hover {
    background: rgba(255,255,255,0.03);
  }

  .ink-home-screen .professor-card-content,
  .ink-home-screen .professor-arquivos-list,
  .ink-home-screen .professor-aula-box,
  .ink-home-screen .submission-card,
  .ink-home-screen .submission-content,
  .ink-home-screen .student-submission-card {
    min-width: 0;
  }

  .ink-home-screen .professor-card-meta strong,
  .ink-home-screen .professor-aula-title,
  .ink-home-screen .professor-card-content strong,
  .ink-home-screen .professor-card-content h4,
  .ink-home-screen .professor-card-content h5,
  .ink-home-screen .professor-card-content label,
  .ink-home-screen .professor-card-content p,
  .ink-home-screen .professor-card-content span,
  .ink-home-screen .professor-card-content small,
  .ink-home-screen .professor-card-content div,
  .ink-home-screen .professor-aula-box p,
  .ink-home-screen .professor-aula-box span,
  .ink-home-screen .professor-aula-box label {
    color: #fff;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .ink-home-screen .professor-card-content textarea,
  .ink-home-screen .professor-card-content input,
  .ink-home-screen .professor-aula-box textarea,
  .ink-home-screen .professor-aula-box input,
  .ink-home-screen .professor-aula-box select {
    width: 100%;
    max-width: 100%;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.14);
    color: #fff;
    border-radius: 14px;
    padding: 12px 14px;
    outline: none;
  }

  .ink-home-screen .professor-card-content textarea::placeholder,
  .ink-home-screen .professor-card-content input::placeholder,
  .ink-home-screen .professor-aula-box textarea::placeholder,
  .ink-home-screen .professor-aula-box input::placeholder {
    color: rgba(255,255,255,0.45);
  }

  .ink-home-screen .professor-card-content textarea:focus,
  .ink-home-screen .professor-card-content input:focus,
  .ink-home-screen .professor-aula-box textarea:focus,
  .ink-home-screen .professor-aula-box input:focus,
  .ink-home-screen .professor-aula-box select:focus {
    border-color: rgba(255,91,91,0.45);
    box-shadow: 0 0 0 3px rgba(255,91,91,0.12);
  }

  .ink-home-screen .professor-card-content select,
  .ink-home-screen .professor-aula-box select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: rgba(255,255,255,0.08);
  }

  .ink-home-screen .professor-card-content option,
  .ink-home-screen .professor-aula-box option {
    color: #fff;
    background: #161616;
  }

  .ink-home-screen .professor-arquivo-link,
  .ink-home-screen .professor-card-content a {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .ink-home-screen .professor-alunos-list,
  .ink-home-screen .professor-arquivos-list {
    display: grid;
    gap: 14px;
  }

  .ink-home-screen .professor-card,
  .ink-home-screen .professor-aula-box {
    overflow: hidden;
  }

  .ink-home-screen .professor-card-toggle,
  .ink-home-screen .professor-aula-toggle {
    width: 100%;
    border: none;
    background: transparent;
    color: #fff;
    cursor: pointer;
    text-align: left;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .ink-home-screen .professor-aula-toggle {
    padding: 14px 0;
  }

  .ink-home-screen .professor-card-left {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
  }

  .ink-home-screen .professor-card-meta {
    display: grid;
    gap: 4px;
    min-width: 0;
  }

  .ink-home-screen .professor-card {
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 22px;
    box-shadow: 0 12px 34px rgba(0,0,0,0.18);
    overflow: hidden;
  }

  .ink-home-screen .professor-card-content {
    width: 100%;
    margin: 0;
    padding: 0 18px 18px;
    border-radius: 0;
    background: transparent !important;
    border: none;
    box-shadow: none;
  }

  .ink-home-screen .professor-arquivos-list {
    display: grid;
    gap: 0;
    padding: 10px 0 0;
    background: transparent !important;
  }

  .ink-home-screen .professor-aula-box {
    width: 100%;
    background: transparent !important;
    border-radius: 0;
    border: none;
    border-top: 1px solid rgba(255,255,255,0.08);
    box-shadow: none;
  }

  .ink-home-screen .professor-aula-box:first-child {
    border-top: 1px solid rgba(255,255,255,0.08);
  }

  .ink-home-screen .professor-card-content,
  .ink-home-screen .professor-card-content *,
  .ink-home-screen .professor-arquivos-list,
  .ink-home-screen .professor-arquivos-list *,
  .ink-home-screen .professor-aula-box,
  .ink-home-screen .professor-aula-box * {
    -webkit-text-fill-color: initial;
  }

  .ink-home-screen .professor-aula-title {
    font-weight: 800;
    color: #fff;
  }

  .ink-home-screen .professor-aula-count,
  .ink-home-screen .professor-toggle-symbol {
    color: rgba(255,255,255,0.66);
    font-weight: 800;
  }

  .ink-home-screen .professor-arquivo-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 14px;
    border-radius: 12px;
    background: rgba(255,91,91,0.14);
    border: 1px solid rgba(255,91,91,0.24);
    color: #ff9a9a;
    font-size: 0.92rem;
    font-weight: 800;
    text-decoration: none;
    transition: transform .18s ease, opacity .18s ease;
  }

  .ink-home-screen .professor-arquivo-link:hover {
    transform: translateY(-1px);
  }

  .ink-home-screen .professor-card-content,
  .ink-home-screen .professor-card-content * ,
  .ink-home-screen .professor-arquivos-list,
  .ink-home-screen .professor-arquivos-list * {
    color: #fff;
  }

  .ink-home-screen .professor-card-content small,
  .ink-home-screen .professor-card-content .muted,
  .ink-home-screen .professor-card-email,
  .ink-home-screen .professor-card-uid,
  .ink-home-screen .professor-helper-text {
    color: rgba(255,255,255,0.78) !important;
  }

  .ink-home-screen .professor-card-content button,
  .ink-home-screen .professor-arquivos-list button {
    color: #fff !important;
  }

  .ink-home-screen .professor-card-content input[type="file"] {
    color: #fff !important;
    background: transparent !important;
    padding: 0 !important;
    border: none !important;
  }

  .ink-home-screen .professor-card-content input[type="file"]::file-selector-button {
    margin-right: 10px;
    border: 1px solid rgba(255,255,255,0.14);
    background: rgba(255,255,255,0.08);
    color: #fff;
    border-radius: 10px;
    padding: 10px 12px;
    cursor: pointer;
  }

  .ink-home-screen .professor-card-content textarea,
  .ink-home-screen .professor-card-content input,
  .ink-home-screen .professor-card-content select,
  .ink-home-screen .professor-aula-box textarea,
  .ink-home-screen .professor-aula-box input,
  .ink-home-screen .professor-aula-box select {
    color: #fff !important;
    background: rgba(255,255,255,0.08) !important;
  }

  .ink-home-screen .professor-card-content button,
  .ink-home-screen .professor-aula-box button {
    -webkit-text-fill-color: currentColor;
  }

  .ink-home-screen .professor-aula-content {
    width: 100%;
    padding: 0 0 18px;
  }

  .ink-home-screen .professor-files-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 0 0 14px;
  }

  .ink-home-screen .professor-review-box {
    width: 100%;
    margin-top: 6px;
    padding: 16px;
    border-radius: 16px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.035);
  }

  .ink-home-screen .auth-box {
    width: 100%;
    max-width: 460px;
    margin: 0 auto;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.10);
    border-radius: 24px;
    padding: 22px;
    text-align: center;
    box-shadow: 0 18px 60px rgba(0,0,0,0.34);
  }

  .ink-home-screen textarea,
  .ink-home-screen input[type="file"] {
    font-family: inherit;
  }

  @media (max-width: 860px) {
    .ink-home-screen .home-container {
      padding: 18px;
      border-radius: 22px;
    }

    .ink-home-screen .aulas-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 8px;
    }

    .ink-home-screen .logout-floating-btn {
      min-width: 90px;
      font-size: 0.88rem;
      padding: 8px 10px;
    }
  }

  @media (max-width: 640px) {
    .ink-home-screen {
      padding: 12px 12px 38px;
    }

    .ink-home-screen .aluno-section,
    .ink-home-screen .home-grid-section,
    .ink-home-screen .professor-section {
      padding: 18px;
      border-radius: 20px;
    }

    .ink-home-screen .professor-card-toggle,
    .ink-home-screen .professor-aula-toggle {
      padding: 14px;
    }

    .ink-home-screen .professor-card-content {
      padding: 0 14px 14px;
    }

    .ink-home-screen .professor-aula-content {
      padding: 0 0 14px;
    }

    .ink-home-screen .home-topbar {
      margin-bottom: 12px;
    }
  }
`;


export default function HomeScreen({ user, onOpenLesson }) {
  const [aluno, setAluno] = useState(null);
  const [loadingAluno, setLoadingAluno] = useState(true);
  const [mostrarMatricula, setMostrarMatricula] = useState(false);

  const [teacherLoading, setTeacherLoading] = useState(false);
  const [teacherError, setTeacherError] = useState('');
  const [teacherEntregas, setTeacherEntregas] = useState([]);
  const [teacherExpandedAluno, setTeacherExpandedAluno] = useState('');
  const [teacherExpandedAulas, setTeacherExpandedAulas] = useState({});

  const [teacherReviewDrafts, setTeacherReviewDrafts] = useState({});
  const [teacherSavingKey, setTeacherSavingKey] = useState('');
  const [teacherSaveNotice, setTeacherSaveNotice] = useState({
    key: '',
    type: '',
    text: '',
  });

  const [myCorrecoesMap, setMyCorrecoesMap] = useState({});
  const [loadingMyCorrecoes, setLoadingMyCorrecoes] = useState(false);

  const [remoteAulasMap, setRemoteAulasMap] = useState({});
  const [lessonReleaseSaving, setLessonReleaseSaving] = useState('');
  const [lessonReleaseNotice, setLessonReleaseNotice] = useState({
    slug: '',
    type: '',
    text: '',
  });

  const isProfessor = user?.email?.toLowerCase?.() === 'rodrigorasilva@hotmail.com';

  const createReviewKey = (alunoUid, aulaSlug) => `${alunoUid}__${aulaSlug}`;

  const createEmptyReviewDraft = () => ({
    status: '',
    comentario: '',
    correctionImageUrl: '',
    correctionImagePath: '',
    selectedFile: null,
    selectedFileName: '',
  });

  const acceptedImageTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];

  const isSupportedCorrectionImage = (file) => {
    if (!file) return false;
    return acceptedImageTypes.includes(file.type);
  };

  const getStatusLabel = (status) => {
    if (status === 'approved') return '✔ Aprovado';
    if (status === 'rejected') return '✖ Corrigir';
    return 'Sem correção';
  };

  const getStatusColor = (status) => {
    if (status === 'approved') return '#37c871';
    if (status === 'rejected') return '#ff5f5f';
    return '#bdbdbd';
  };

  const formatarData = (dataString) => {
    const [ano, mes, dia] = dataString.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  const formatarDataHora = (dateValue) => {
    if (!dateValue) return '';
    try {
      return new Date(dateValue).toLocaleString('pt-BR');
    } catch {
      return '';
    }
  };

  const sanitizarNomeArquivo = (nome = '') =>
    nome
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '_')
      .replace(/[^\w.-]/g, '');

  const hoje = new Date();

  const aulas = useMemo(
    () => [
      {
        numero: 1,
        data: '2026-04-01',
        titulo: 'Aula 1 - Introdução',
        slug: 'aula-1',
        liberada: true,
      },
      {
        numero: 2,
        data: '2026-04-08',
        titulo: 'Aula 2',
        slug: 'aula-2',
        liberada: true,
      },
      {
        numero: 3,
        data: '2026-04-15',
        titulo: 'Aula 3',
        slug: 'aula-3',
        liberada: false,
      },
      {
        numero: 4,
        data: '2026-04-22',
        titulo: 'Aula 4',
        slug: 'aula-4',
        liberada: true,
      },
      {
        numero: 5,
        data: '2026-04-29',
        titulo: 'Aula 5',
        slug: 'aula-5',
        liberada: true,
      },
      {
        numero: 6,
        data: '2026-05-06',
        titulo: 'Aula 6',
        slug: 'aula-6',
        liberada: true,
      },
      {
        numero: 7,
        data: '2026-05-13',
        titulo: 'Aula 7',
        slug: 'aula-7',
        liberada: false,
      },
      {
        numero: 8,
        data: '2026-05-20',
        titulo: 'Aula 8',
        slug: 'aula-8',
        liberada: false,
      },
      {
        numero: 9,
        data: '2026-05-27',
        titulo: 'Aula 9',
        slug: 'aula-9',
        liberada: false,
      },
      {
        numero: 10,
        data: '2026-06-03',
        titulo: 'Aula 10',
        slug: 'aula-10',
        liberada: false,
      },
      {
        numero: 11,
        data: '2026-06-10',
        titulo: 'Aula 11',
        slug: 'aula-11',
        liberada: false,
      },
      {
        numero: 12,
        data: '2026-06-17',
        titulo: 'Aula 12',
        slug: 'aula-12',
        liberada: false,
      },
      {
        numero: 13,
        data: '2026-06-24',
        titulo: 'Aula 13',
        slug: 'aula-13',
        liberada: false,
      },
      {
        numero: 14,
        data: '2026-07-01',
        titulo: 'Aula 14',
        slug: 'aula-14',
        liberada: false,
      },
    ],
    []
  );

  const feedbackRecebidos = useMemo(() => {
    return aulas
      .map((aula) => ({
        aula,
        correcao: myCorrecoesMap[aula.slug] || null,
      }))
      .filter((item) => item.correcao);
  }, [aulas, myCorrecoesMap]);

  const verificarLiberacaoAluno = (aula) => {
    const remoteAula = remoteAulasMap[aula.slug] || {};

    if (typeof remoteAula.liberadaManual === 'boolean') {
      return remoteAula.liberadaManual;
    }

    if (typeof remoteAula.liberada === 'boolean') {
      return remoteAula.liberada;
    }

    if (aula?.liberada === true) return true;

    const dataAula = new Date(`${aula.data}T00:00:00`);
    return dataAula <= hoje;
  };

  const verificarSeLiberada = (aula) => {
    if (isProfessor) return true;
    return verificarLiberacaoAluno(aula);
  };

  const getAulaCardStatus = (aula, correcao) => {
    const liberadaParaAluno = verificarLiberacaoAluno(aula);

    if (!liberadaParaAluno) {
      return {
        label: isProfessor ? 'BLOQUEADA PARA ALUNO' : 'BLOQUEADA',
        color: '#ff8d8d',
      };
    }

    if (correcao?.status === 'approved') {
      return {
        label: 'APROVADO',
        color: '#37c871',
      };
    }

    return {
      label: 'LIBERADA',
      color: '#8dd8ff',
    };
  };

  useEffect(() => {
    const styleId = 'ink-home-screen-styles';
    let styleTag = document.getElementById(styleId);

    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      styleTag.innerHTML = homeInjectedStyles;
      document.head.appendChild(styleTag);
    }
  }, []);

  useEffect(() => {
    const loadRemoteAulas = async () => {
      if (!user?.uid) {
        setRemoteAulasMap({});
        return;
      }

      try {
        const aulasConteudoSnap = await getDocs(collection(db, 'aulas_conteudo'));
        const nextMap = {};

        aulasConteudoSnap.forEach((docSnap) => {
          nextMap[docSnap.id] = docSnap.data();
        });

        setRemoteAulasMap(nextMap);
      } catch (error) {
        console.error('Erro ao carregar liberação das aulas:', error);
        setRemoteAulasMap({});
      }
    };

    loadRemoteAulas();
  }, [user?.uid]);

  useEffect(() => {
    const loadAluno = async () => {
      try {
        setLoadingAluno(true);

        const alunoRef = doc(db, 'alunos', user.uid);
        const alunoSnap = await getDoc(alunoRef);

        if (alunoSnap.exists()) {
          setAluno(alunoSnap.data());
        } else {
          setAluno(null);
        }
      } catch (error) {
        console.error('Erro ao carregar aluno:', error);
      } finally {
        setLoadingAluno(false);
      }
    };

    if (user?.uid) {
      loadAluno();
    }
  }, [user]);

  useEffect(() => {
    const loadCorrecoes = async () => {
      if (!user?.uid) return;

      try {
        setLoadingMyCorrecoes(true);

        if (isProfessor) {
          const allCorrecoesSnap = await getDocs(collection(db, 'correcoes_entregas'));

          const draftsMap = {};

          allCorrecoesSnap.forEach((docSnap) => {
            const data = docSnap.data();
            if (!data?.alunoUid || !data?.aulaSlug) return;

            const reviewKey = createReviewKey(data.alunoUid, data.aulaSlug);

            draftsMap[reviewKey] = {
              status: data.status || '',
              comentario: data.comentario || '',
              correctionImageUrl: data.correctionImageUrl || '',
              correctionImagePath: data.correctionImagePath || '',
              selectedFile: null,
              selectedFileName: '',
            };
          });

          setTeacherReviewDrafts((prev) => ({
            ...draftsMap,
            ...prev,
          }));
        }

        const minhasCorrecoesRef = query(
          collection(db, 'correcoes_entregas'),
          where('alunoUid', '==', user.uid)
        );

        const minhasCorrecoesSnap = await getDocs(minhasCorrecoesRef);
        const nextCorrecoesMap = {};

        minhasCorrecoesSnap.forEach((docSnap) => {
          const data = docSnap.data();
          if (!data?.aulaSlug) return;

          nextCorrecoesMap[data.aulaSlug] = {
            status: data.status || '',
            comentario: data.comentario || '',
            correctionImageUrl: data.correctionImageUrl || '',
            professorNome: data.professorNome || 'Rodrigo',
            updatedAt:
              data.updatedAt?.seconds != null
                ? new Date(data.updatedAt.seconds * 1000)
                : null,
          };
        });

        setMyCorrecoesMap(nextCorrecoesMap);
      } catch (error) {
        console.error('Erro ao carregar correções:', error);
      } finally {
        setLoadingMyCorrecoes(false);
      }
    };

    loadCorrecoes();
  }, [user?.uid, isProfessor]);

  useEffect(() => {
    const buscarDadosAlunoEntrega = async (identificadorPasta) => {
      const valor = String(identificadorPasta || '').trim();

      let alunoNome = 'Aluno sem nome';
      let alunoEmail = '';
      let alunoUidExibicao = valor || '—';

      try {
        const usuariosRef = collection(db, 'usuarios_dispositivos_autorizados');

        const qUid = query(usuariosRef, where('uid', '==', valor), limit(1));
        const resultadoUid = await getDocs(qUid);

        if (!resultadoUid.empty) {
          const docEncontrado = resultadoUid.docs[0];
          const alunoData = docEncontrado.data();

          return {
            alunoNome: alunoData?.nome || 'Aluno sem nome',
            alunoEmail: alunoData?.email || '',
            alunoUidExibicao: alunoData?.uid || valor || docEncontrado.id,
          };
        }

        const qNome = query(usuariosRef, where('nome', '==', valor), limit(1));
        const resultadoNome = await getDocs(qNome);

        if (!resultadoNome.empty) {
          const docEncontrado = resultadoNome.docs[0];
          const alunoData = docEncontrado.data();

          return {
            alunoNome: alunoData?.nome || valor || 'Aluno sem nome',
            alunoEmail: alunoData?.email || '',
            alunoUidExibicao: alunoData?.uid || docEncontrado.id || valor,
          };
        }

        return {
          alunoNome: valor || alunoNome,
          alunoEmail,
          alunoUidExibicao,
        };
      } catch (error) {
        console.error(`Erro ao buscar dados do aluno ${valor}:`, error);

        return {
          alunoNome: valor || alunoNome,
          alunoEmail,
          alunoUidExibicao,
        };
      }
    };

    const loadTeacherEntregas = async () => {
      if (!isProfessor) {
        setTeacherEntregas([]);
        return;
      }

      try {
        setTeacherLoading(true);
        setTeacherError('');

        const entregasRootRef = ref(storage, 'entregas');
        const alunosResult = await listAll(entregasRootRef);

        const alunosData = [];

        for (const alunoPrefixRef of alunosResult.prefixes) {
          const identificadorPasta = alunoPrefixRef.name;
          const dadosAluno = await buscarDadosAlunoEntrega(identificadorPasta);

          const aulasResult = await listAll(alunoPrefixRef);
          const aulasData = [];

          for (const aulaPrefixRef of aulasResult.prefixes) {
            const filesResult = await listAll(aulaPrefixRef);

            const arquivos = await Promise.all(
              filesResult.items.map(async (fileRef) => {
                const url = await getDownloadURL(fileRef);
                return {
                  nome: fileRef.name,
                  url,
                };
              })
            );

            arquivos.sort((a, b) => a.nome.localeCompare(b.nome));

            aulasData.push({
              aulaSlug: aulaPrefixRef.name,
              arquivos,
            });
          }

          aulasData.sort((a, b) => a.aulaSlug.localeCompare(b.aulaSlug));

          alunosData.push({
            alunoUid: dadosAluno.alunoUidExibicao || identificadorPasta,
            alunoNome: dadosAluno.alunoNome || identificadorPasta || 'Aluno sem nome',
            alunoEmail: dadosAluno.alunoEmail || '',
            aulas: aulasData,
          });
        }

        alunosData.sort((a, b) => a.alunoNome.localeCompare(b.alunoNome));
        setTeacherEntregas(alunosData);
      } catch (error) {
        console.error('Erro ao carregar entregas dos alunos:', error);
        setTeacherError('Não foi possível carregar os arquivos enviados pelos alunos.');
      } finally {
        setTeacherLoading(false);
      }
    };

    loadTeacherEntregas();
  }, [isProfessor]);

  const handleAbrirAula = (aula) => {
    const liberada = verificarSeLiberada(aula);
    if (!liberada && !isProfessor) return;

    if (typeof onOpenLesson === 'function') {
      onOpenLesson(aula.slug);
    }
  };

  const handleToggleLiberacaoAula = async (event, aula) => {
    event.stopPropagation();

    if (!isProfessor) return;

    try {
      const liberadaAtual = verificarLiberacaoAluno(aula);
      const proximaLiberacao = !liberadaAtual;

      setLessonReleaseSaving(aula.slug);
      setLessonReleaseNotice({ slug: '', type: '', text: '' });

      await setDoc(
        doc(db, 'aulas_conteudo', aula.slug),
        {
          liberada: proximaLiberacao,
          liberadaManual: proximaLiberacao,
          updatedAt: serverTimestamp(),
          updatedBy: user?.email || '',
        },
        { merge: true }
      );

      setRemoteAulasMap((prev) => ({
        ...prev,
        [aula.slug]: {
          ...(prev[aula.slug] || {}),
          liberada: proximaLiberacao,
          liberadaManual: proximaLiberacao,
          updatedBy: user?.email || '',
        },
      }));

      setLessonReleaseNotice({
        slug: aula.slug,
        type: 'success',
        text: proximaLiberacao
          ? `Aula ${aula.numero} liberada para os alunos.`
          : `Aula ${aula.numero} bloqueada para os alunos.`,
      });
    } catch (error) {
      console.error('Erro ao alterar liberação da aula:', error);
      setLessonReleaseNotice({
        slug: aula.slug,
        type: 'error',
        text: 'Não foi possível alterar a liberação da aula.',
      });
    } finally {
      setLessonReleaseSaving('');
    }
  };

  const handleLogout = async () => {
    try {
      localStorage.setItem('ink_current_screen', 'home');
      localStorage.removeItem('ink_selected_lesson_slug');
      await signOut(auth);
    } catch (error) {
      console.error('Erro ao sair:', error);
    }
  };

  const handleTeacherReviewFieldChange = (alunoUid, aulaSlug, field, value) => {
    const reviewKey = createReviewKey(alunoUid, aulaSlug);

    setTeacherReviewDrafts((prev) => ({
      ...prev,
      [reviewKey]: {
        ...(prev[reviewKey] || createEmptyReviewDraft()),
        [field]: value,
      },
    }));
  };

  const handleTeacherImageChange = (alunoUid, aulaSlug, file) => {
    const reviewKey = createReviewKey(alunoUid, aulaSlug);

    if (file && !isSupportedCorrectionImage(file)) {
      setTeacherSaveNotice({
        key: reviewKey,
        type: 'error',
        text: 'Use somente PNG, JPG, JPEG ou WEBP na imagem de correção.',
      });

      setTeacherReviewDrafts((prev) => ({
        ...prev,
        [reviewKey]: {
          ...(prev[reviewKey] || createEmptyReviewDraft()),
          selectedFile: null,
          selectedFileName: '',
        },
      }));
      return;
    }

    setTeacherSaveNotice({ key: '', type: '', text: '' });

    setTeacherReviewDrafts((prev) => ({
      ...prev,
      [reviewKey]: {
        ...(prev[reviewKey] || createEmptyReviewDraft()),
        selectedFile: file || null,
        selectedFileName: file?.name || '',
      },
    }));
  };

  const handleSalvarCorrecao = async (alunoEntrega, aulaEntrega) => {
    const reviewKey = createReviewKey(alunoEntrega.alunoUid, aulaEntrega.aulaSlug);
    const draft = teacherReviewDrafts[reviewKey] || createEmptyReviewDraft();

    try {
      setTeacherSavingKey(reviewKey);
      setTeacherSaveNotice({ key: '', type: '', text: '' });

      let correctionImageUrl = draft.correctionImageUrl || '';
      let correctionImagePath = draft.correctionImagePath || '';

      if (draft.selectedFile) {
        if (!isSupportedCorrectionImage(draft.selectedFile)) {
          throw new Error('Formato de imagem não suportado. Use PNG, JPG, JPEG ou WEBP.');
        }

        const nomeArquivoLimpo = sanitizarNomeArquivo(draft.selectedFile.name);
        const imagePath = `correcoes/${alunoEntrega.alunoUid}/${aulaEntrega.aulaSlug}/${Date.now()}-${nomeArquivoLimpo}`;
        const imageRef = ref(storage, imagePath);

        await uploadBytes(imageRef, draft.selectedFile, {
          contentType: draft.selectedFile.type || 'image/jpeg',
        });

        correctionImageUrl = await getDownloadURL(imageRef);
        correctionImagePath = imagePath;
      }

      const payload = {
        alunoUid: alunoEntrega.alunoUid,
        alunoNome: alunoEntrega.alunoNome || '',
        alunoEmail: alunoEntrega.alunoEmail || '',
        aulaSlug: aulaEntrega.aulaSlug,
        status: draft.status || '',
        comentario: (draft.comentario || '').trim(),
        correctionImageUrl,
        correctionImagePath,
        professorNome: user?.displayName || 'Rodrigo',
        professorEmail: user?.email || '',
        updatedAt: serverTimestamp(),
      };

      await setDoc(doc(db, 'correcoes_entregas', reviewKey), payload, { merge: true });

      setTeacherReviewDrafts((prev) => ({
        ...prev,
        [reviewKey]: {
          ...(prev[reviewKey] || createEmptyReviewDraft()),
          status: payload.status,
          comentario: payload.comentario,
          correctionImageUrl,
          correctionImagePath,
          selectedFile: null,
          selectedFileName: '',
        },
      }));

      setTeacherSaveNotice({
        key: reviewKey,
        type: 'success',
        text: 'Correção salva com sucesso.',
      });
    } catch (error) {
      console.error('Erro ao salvar correção:', error);
      setTeacherSaveNotice({
        key: reviewKey,
        type: 'error',
        text: error?.message || 'Não foi possível salvar a correção.',
      });
    } finally {
      setTeacherSavingKey('');
    }
  };

  const matriculaBase = aluno?.matricula || user?.uid || '—';
  const matriculaExibida = mostrarMatricula
    ? matriculaBase
    : '•'.repeat(Math.max(8, String(matriculaBase).length));

  if (loadingAluno) {
    return (
      <div className="container2">
        <div className="container">
          <div className="auth-box">
            <h2>Carregando...</h2>
            <p>Buscando dados do aluno.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container2 home-shell ink-home-screen">
      <div className="home-topbar">
        <button type="button" className="logout-floating-btn" onClick={handleLogout}>
          Sair
        </button>
      </div>

      <div className="container home-container">
        <section className="home-grid-section">
          <div className="section-head">
            <span className="aluno-badge-light">ÁREA DO ALUNO</span>
          </div>

          <div className="aulas-grid-wrap">
            <div className="aulas-grid">
              {aulas.map((aula) => {
                const correcao = myCorrecoesMap[aula.slug];
                const liberada = verificarSeLiberada(aula);
                const liberadaParaAluno = verificarLiberacaoAluno(aula);
                const statusAula = getAulaCardStatus(aula, correcao);
                const salvandoLiberacao = lessonReleaseSaving === aula.slug;

                return (
                  <div
                    key={aula.numero}
                    role="button"
                    tabIndex={liberada ? 0 : -1}
                    onClick={() => handleAbrirAula(aula)}
                    onKeyDown={(event) => {
                      if ((event.key === 'Enter' || event.key === ' ') && liberada) {
                        event.preventDefault();
                        handleAbrirAula(aula);
                      }
                    }}
                    className={`aula-card aula-card-button ${liberada ? 'liberada' : 'bloqueada'}`}
                    style={{
                      opacity: liberada ? 1 : 0.68,
                      cursor: liberada ? 'pointer' : 'not-allowed',
                    }}
                  >
                    <div className="aula-numero">AULA {aula.numero}</div>

                    <div
                      className={`aula-status ${
                        liberadaParaAluno ? 'status-liberada' : 'status-bloqueada'
                      }`}
                      style={{
                        fontSize: 10,
                        color: statusAula.color,
                      }}
                    >
                      {statusAula.label}
                    </div>

                    <div className="aula-data">{formatarData(aula.data)}</div>

                    {isProfessor && (
                      <div
                        style={{
                          width: '100%',
                          marginTop: 'auto',
                          display: 'grid',
                          gap: 6,
                        }}
                      >
                        <button
                          type="button"
                          onClick={(event) => handleToggleLiberacaoAula(event, aula)}
                          disabled={salvandoLiberacao}
                          style={{
                            width: '100%',
                            border: '1px solid rgba(255,255,255,0.12)',
                            borderRadius: 10,
                            padding: '8px 8px',
                            background: liberadaParaAluno ? '#249a56' : '#d93a3a',
                            color: '#fff',
                            fontSize: 10,
                            fontWeight: 900,
                            cursor: salvandoLiberacao ? 'not-allowed' : 'pointer',
                            opacity: salvandoLiberacao ? 0.72 : 1,
                          }}
                        >
                          {salvandoLiberacao
                            ? 'Salvando...'
                            : liberadaParaAluno
                              ? 'Bloquear aula'
                              : 'Desbloquear aula'}
                        </button>

                        {lessonReleaseNotice.slug === aula.slug ? (
                          <small
                            style={{
                              color:
                                lessonReleaseNotice.type === 'success'
                                  ? '#7ff0ab'
                                  : '#ff9a9a',
                              fontSize: 10,
                              lineHeight: 1.25,
                              fontWeight: 800,
                            }}
                          >
                            {lessonReleaseNotice.text}
                          </small>
                        ) : null}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {!isProfessor && (
          <section className="professor-section">
            <div className="section-head">
              <span className="aluno-badge-light">FEEDBACK DO PROFESSOR</span>
              <h3 className="course-title">Correções recebidas</h3>
              <p className="section-subtitle">
                Aqui vão aparecer suas observações e imagens de correção por aula.
              </p>
            </div>

            <div className="professor-panel">
              {loadingMyCorrecoes ? (
                <p className="professor-helper-text">Carregando correções...</p>
              ) : feedbackRecebidos.length > 0 ? (
                <div
                  style={{
                    display: 'grid',
                    gap: 14,
                  }}
                >
                  {feedbackRecebidos.map(({ aula, correcao }) => (
                    <div
                      key={aula.slug}
                      style={{
                        width: '100%',
                        background: '#151515',
                        border: '1px solid rgba(255,255,255,0.08)',
                        borderRadius: 18,
                        padding: 16,
                        boxShadow: '0 10px 24px rgba(0,0,0,0.22)',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 12,
                          flexWrap: 'wrap',
                          marginBottom: 14,
                        }}
                      >
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 8,
                            background: 'rgba(241, 196, 15, 0.12)',
                            color: '#f1c40f',
                            border: '1px solid rgba(241, 196, 15, 0.22)',
                            borderRadius: 999,
                            padding: '7px 12px',
                            fontSize: 10,
                            fontWeight: 800,
                            letterSpacing: 0.5,
                          }}
                        >
                          FEEDBACK DA AULA {aula.numero}
                        </div>

                        <span
                          style={{
                            fontSize: 12,
                            color: 'rgba(255,255,255,0.55)',
                          }}
                        >
                          {correcao.updatedAt
                            ? formatarDataHora(correcao.updatedAt)
                            : 'Agora há pouco'}
                        </span>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 12,
                        }}
                      >
                        <div
                          style={{
                            width: 42,
                            height: 42,
                            minWidth: 42,
                            borderRadius: '50%',
                            background: '#232323',
                            border: '1px solid rgba(255,255,255,0.10)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#ffffff',
                            fontSize: 16,
                            fontWeight: 900,
                          }}
                        >
                          {(correcao.professorNome || 'R').charAt(0).toUpperCase()}
                        </div>

                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              flexWrap: 'wrap',
                              marginBottom: 2,
                            }}
                          >
                            <strong
                              style={{
                                color: '#ffffff',
                                fontSize: 14,
                                fontWeight: 800,
                              }}
                            >
                              {correcao.professorNome || 'Rodrigo'}
                            </strong>

                            <span
                              style={{
                                color: 'rgba(255,255,255,0.55)',
                                fontSize: 12,
                              }}
                            >
                              comentou em {aula.titulo}
                            </span>
                          </div>

                          <div
                            style={{
                              color: 'rgba(255,255,255,0.70)',
                              fontSize: 14,
                              lineHeight: 1.6,
                              whiteSpace: 'pre-wrap',
                              marginTop: 10,
                            }}
                          >
                            {correcao.comentario || 'Sem comentário escrito.'}
                          </div>

                          {correcao.correctionImageUrl ? (
                            <div style={{ marginTop: 14 }}>
                              <a
                                href={correcao.correctionImageUrl}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  padding: '10px 14px',
                                  borderRadius: 12,
                                  background: '#249a56',
                                  color: '#111111',
                                  fontSize: 13,
                                  fontWeight: 800,
                                  textDecoration: 'none',
                                  boxShadow: '0 8px 18px rgba(55,200,113,0.22)',
                                }}
                              >
                                Abrir imagem de correção
                              </a>

                              <div
                                style={{
                                  marginTop: 8,
                                  fontSize: 12,
                                  color: 'rgba(255,255,255,0.45)',
                                }}
                              >
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="professor-helper-text">
                  Quando o professor corrigir suas atividades, elas vão aparecer aqui.
                </p>
              )}
            </div>
          </section>
        )}

        {isProfessor && (
          <section className="professor-section">
            <div className="section-head">
              <span className="aluno-badge-light">ÁREA DO PROFESSOR</span>
              <h3 className="course-title">Envios dos alunos</h3>
              <p className="section-subtitle">
                Visualize os alunos, as aulas entregues, abra os arquivos e registre a correção.
              </p>
            </div>

            <div className="professor-panel">
              {teacherLoading ? (
                <p className="professor-helper-text">Carregando entregas dos alunos...</p>
              ) : teacherError ? (
                <p className="professor-helper-text">{teacherError}</p>
              ) : teacherEntregas.length > 0 ? (
                <div className="professor-alunos-list">
                  {teacherEntregas.map((alunoEntrega) => {
                    const alunoAberto = teacherExpandedAluno === alunoEntrega.alunoUid;

                    return (
                      <div key={alunoEntrega.alunoUid} className="professor-card">
                        <button
                          type="button"
                          className="professor-card-toggle"
                          onClick={() =>
                            setTeacherExpandedAluno((prev) =>
                              prev === alunoEntrega.alunoUid ? '' : alunoEntrega.alunoUid
                            )
                          }
                        >
                          <div className="professor-card-left">
                            <div className="professor-avatar">
                              {(alunoEntrega.alunoNome || 'A').charAt(0).toUpperCase()}
                            </div>

                            <div className="professor-card-meta">
                              <strong className="professor-card-name">
                                {alunoEntrega.alunoNome}
                              </strong>

                              <span className="professor-card-email">
                                {alunoEntrega.alunoEmail || 'Sem e-mail cadastrado'}
                              </span>

                              <span className="professor-card-uid">
                                UID: {alunoEntrega.alunoUid}
                              </span>
                            </div>
                          </div>

                          <span className="professor-toggle-symbol">
                            {alunoAberto ? '−' : '+'}
                          </span>
                        </button>

                        {alunoAberto && (
                          <div className="professor-card-content">
                            {alunoEntrega.aulas.length > 0 ? (
                              alunoEntrega.aulas.map((aulaEntrega) => {
                                const aulaKey = `${alunoEntrega.alunoUid}-${aulaEntrega.aulaSlug}`;
                                const aulaAberta = !!teacherExpandedAulas[aulaKey];
                                const reviewKey = createReviewKey(
                                  alunoEntrega.alunoUid,
                                  aulaEntrega.aulaSlug
                                );
                                const draft =
                                  teacherReviewDrafts[reviewKey] || createEmptyReviewDraft();

                                return (
                                  <div key={aulaKey} className="professor-aula-box">
                                    <button
                                      type="button"
                                      className="professor-aula-toggle"
                                      onClick={() =>
                                        setTeacherExpandedAulas((prev) => ({
                                          ...prev,
                                          [aulaKey]: !prev[aulaKey],
                                        }))
                                      }
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 12,
                                          minWidth: 0,
                                          flex: 1,
                                          flexWrap: 'wrap',
                                        }}
                                      >
                                        <span className="professor-aula-title">
                                          {aulaEntrega.aulaSlug}
                                        </span>

                                        <span className="professor-aula-count">
                                          {aulaEntrega.arquivos.length} arquivo(s)
                                        </span>
                                      </div>

                                      <span className="professor-toggle-symbol">
                                        {aulaAberta ? 'Ocultar' : 'Abrir'}
                                      </span>
                                    </button>

                                    {aulaAberta && (
                                      <div className="professor-aula-content">
                                        {aulaEntrega.arquivos.length > 0 ? (
                                          <div className="professor-files-grid">
                                            {aulaEntrega.arquivos.map((arquivo) => (
                                              <a
                                                key={arquivo.nome}
                                                href={arquivo.url}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="professor-arquivo-link"
                                              >
                                                {arquivo.nome}
                                              </a>
                                            ))}
                                          </div>
                                        ) : (
                                          <p className="professor-helper-text">
                                            Nenhum arquivo nesta aula.
                                          </p>
                                        )}

                                        <div className="professor-review-box">
                                          <div
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              flexWrap: 'wrap',
                                              gap: 10,
                                              marginBottom: 12,
                                            }}
                                          >
                                            <strong style={{ fontSize: 14 }}>
                                              Correção do professor
                                            </strong>

                                            <span
                                              style={{
                                                fontWeight: 800,
                                                color: getStatusColor(draft.status),
                                              }}
                                            >
                                              {getStatusLabel(draft.status)}
                                            </span>
                                          </div>

                                          <div
                                            style={{
                                              display: 'flex',
                                              gap: 8,
                                              flexWrap: 'wrap',
                                              marginBottom: 12,
                                            }}
                                          >
                                            <button
                                              type="button"
                                              onClick={() =>
                                                handleTeacherReviewFieldChange(
                                                  alunoEntrega.alunoUid,
                                                  aulaEntrega.aulaSlug,
                                                  'status',
                                                  'approved'
                                                )
                                              }
                                              style={{
                                                border: 'none',
                                                cursor: 'pointer',
                                                borderRadius: 10,
                                                padding: '10px 14px',
                                                fontWeight: 800,
                                                background:
                                                  draft.status === 'approved'
                                                    ? '#37c871'
                                                    : 'rgba(55, 200, 113, 0.14)',
                                                color:
                                                  draft.status === 'approved'
                                                    ? '#111'
                                                    : '#7ff0ab',
                                              }}
                                            >
                                              ✔ Check
                                            </button>

                                            <button
                                              type="button"
                                              onClick={() =>
                                                handleTeacherReviewFieldChange(
                                                  alunoEntrega.alunoUid,
                                                  aulaEntrega.aulaSlug,
                                                  'status',
                                                  'rejected'
                                                )
                                              }
                                              style={{
                                                border: 'none',
                                                cursor: 'pointer',
                                                borderRadius: 10,
                                                padding: '10px 14px',
                                                fontWeight: 800,
                                                background:
                                                  draft.status === 'rejected'
                                                    ? '#ff5f5f'
                                                    : 'rgba(255, 95, 95, 0.14)',
                                                color:
                                                  draft.status === 'rejected'
                                                    ? '#111'
                                                    : '#ff9a9a',
                                              }}
                                            >
                                              ✖ X
                                            </button>

                                            <button
                                              type="button"
                                              onClick={() =>
                                                setTeacherReviewDrafts((prev) => ({
                                                  ...prev,
                                                  [reviewKey]: {
                                                    ...createEmptyReviewDraft(),
                                                  },
                                                }))
                                              }
                                              style={{
                                                border: 'none',
                                                cursor: 'pointer',
                                                borderRadius: 10,
                                                padding: '10px 14px',
                                                fontWeight: 800,
                                                background: 'rgba(255,255,255,0.08)',
                                                color: '#fff',
                                              }}
                                            >
                                              Limpar
                                            </button>
                                          </div>

                                          <textarea
                                            value={draft.comentario}
                                            onChange={(e) =>
                                              handleTeacherReviewFieldChange(
                                                alunoEntrega.alunoUid,
                                                aulaEntrega.aulaSlug,
                                                'comentario',
                                                e.target.value
                                              )
                                            }
                                            placeholder="Escreva aqui sua opinião, correção ou observação sobre a atividade..."
                                            style={{
                                              width: '100%',
                                              minHeight: 120,
                                              resize: 'vertical',
                                              borderRadius: 12,
                                              padding: 12,
                                              background: 'rgba(0,0,0,0.25)',
                                              color: '#fff',
                                              border: '1px solid rgba(255,255,255,0.10)',
                                              outline: 'none',
                                              marginBottom: 12,
                                            }}
                                          />

                                          <div style={{ marginBottom: 10 }}>
                                            <label
                                              style={{
                                                display: 'block',
                                                fontSize: 13,
                                                marginBottom: 8,
                                                opacity: 0.9,
                                              }}
                                            >
                                              Enviar imagem de correção
                                            </label>

                                            <input
                                              type="file"
                                              accept="image/png,image/jpeg,image/jpg,image/webp"
                                              onChange={(e) =>
                                                handleTeacherImageChange(
                                                  alunoEntrega.alunoUid,
                                                  aulaEntrega.aulaSlug,
                                                  e.target.files?.[0] || null
                                                )
                                              }
                                              style={{ marginBottom: 8 }}
                                            />

                                            {draft.selectedFileName ? (
                                              <div
                                                style={{
                                                  fontSize: 12,
                                                  color: '#fff',
                                                  marginBottom: 8,
                                                }}
                                              >
                                                Nova imagem selecionada: {draft.selectedFileName}
                                              </div>
                                            ) : null}

                                            {draft.correctionImageUrl ? (
                                              <a
                                                href={draft.correctionImageUrl}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="professor-arquivo-link"
                                                style={{ display: 'inline-block' }}
                                              >
                                                Abrir imagem já salva
                                              </a>
                                            ) : null}
                                          </div>

                                          <button
                                            type="button"
                                            onClick={() =>
                                              handleSalvarCorrecao(alunoEntrega, aulaEntrega)
                                            }
                                            disabled={teacherSavingKey === reviewKey}
                                            style={{
                                              border: 'none',
                                              cursor:
                                                teacherSavingKey === reviewKey
                                                  ? 'not-allowed'
                                                  : 'pointer',
                                              borderRadius: 12,
                                              padding: '12px 16px',
                                              fontWeight: 800,
                                              background:
                                                teacherSavingKey === reviewKey
                                                  ? 'rgba(255,255,255,0.12)'
                                                  : '#d93a3a',
                                              color: '#fff',
                                              opacity: teacherSavingKey === reviewKey ? 0.7 : 1,
                                            }}
                                          >
                                            {teacherSavingKey === reviewKey
                                              ? 'Salvando...'
                                              : 'Salvar correção'}
                                          </button>

                                          {teacherSaveNotice.key === reviewKey ? (
                                            <div
                                              style={{
                                                marginTop: 10,
                                                fontSize: 13,
                                                fontWeight: 700,
                                                color:
                                                  teacherSaveNotice.type === 'success'
                                                    ? '#7ff0ab'
                                                    : '#ff9a9a',
                                              }}
                                            >
                                              {teacherSaveNotice.text}
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            ) : (
                              <p className="professor-helper-text">
                                Esse aluno ainda não enviou arquivos.
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="professor-helper-text">
                  Nenhuma entrega de aluno encontrada até o momento.
                </p>
              )}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}